import { Field } from 'formik';
import React from 'react';
import { Fieldset, RadioButton, Subsection } from '@fourthwall/components';
import { useFormikContext } from '@fourthwall/utils/dist/formik';
import { TimezonedDatePicker } from '../../../../../../../Timezone/components/TimezonedDatePicker';
import * as S from './GiftCardExpirationDate.styled';
export const GiftCardExpirationDate = ({ disabled }) => {
    const { values, errors, setFieldValue } = useFormikContext();
    const renderExpirationDate = () => {
        if (values.expirationDateType === 'NONE') {
            return null;
        }
        return (React.createElement(S.InnerContainer, null,
            React.createElement(Fieldset.Row, null,
                React.createElement(TimezonedDatePicker, { labels: ['Expiration date'], value: [values.expirationDate], showTimeInputs: true, dateFormat: "h:mm A, MMM d, YYYY", onChange: ([date]) => setFieldValue('expirationDate', date), error: errors.expirationDate, minDate: new Date(), disabled: disabled }))));
    };
    return (React.createElement(Subsection, { title: "Expiration date" },
        React.createElement(S.Description, null, "Gift card expiry rules vary by country. Before setting or changing an expiry date, make sure to check the laws in your country."),
        React.createElement(Fieldset, null,
            React.createElement(Fieldset.Row, null,
                React.createElement(Field, { component: RadioButton, name: "expirationDateType", checkedValue: "NONE", label: "No expiration date", disabled: disabled })),
            React.createElement(Fieldset.Row, null,
                React.createElement(Field, { component: RadioButton, name: "expirationDateType", checkedValue: "REQUIRED", label: "Set expiration date", disabled: disabled })),
            renderExpirationDate())));
};
